import { ChangeDetectorRef, Component, OnDestroy, ViewChild } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import * as moment from 'moment';
import { MedicalExamCertificateComponent } from '../../../../medical-review/components/medical-exam-certificate/medical-exam-certificate.component';
import { MedicalReviewService } from '../../../../medical-review/services/medical-review.service';
import { DriverBaseComponent } from '../../../driver-base-component';
import { IncidentConfirmationService } from '../../../services/incident-confirmation/incident-confirmation.service';

@Component({
    templateUrl: './medical-exam-certificate-megamenu-modal.html'
})
export class MedicalExamCertificateMegaMenuModalComponent extends DriverBaseComponent implements OnDestroy {
    public isFormValid = false;
    public saving = false;
    public showEligibilityStatus: boolean;
    public eligibilityStatus: boolean;
    public waiverStatus = '';
    public dateReminder = '';
    public customer: any = null;
    public eligibilityMessage = '';
    public tosExpiration: Date;

    @ViewChild(MedicalExamCertificateComponent) medicalExamCertificate: MedicalExamCertificateComponent;

    constructor(
        public dialogRef: MatDialogRef<MedicalExamCertificateMegaMenuModalComponent>,
        private _medicalReviewService: MedicalReviewService,
        private incidentConfirmationService: IncidentConfirmationService,
        private changeDetectorRef: ChangeDetectorRef
    ) {
        super();
    }

    public ngOnInit() {}

    public customerSelected = (event: boolean): void => {
        this.customer = event;
        this.changeDetectorRef.detectChanges();
        this._medicalReviewService.getMedicalExamCertificateByCustomerNumber(this.customer.customerNumber)
            .subscribe(r => {
                if ((null != r) && (null != r.result) && (null != r.result.medicalExamCertificateSignatureDate)) {
                    this.tosExpiration = moment(r.result.medicalExamCertificateSignatureDate).add(2, 'year').toDate();
                }
            });
    };

    public removeCustomer = (): void => {
        this.customer = null;
        this.showEligibilityStatus = false;
        this.waiverStatus = '';
        this.dateReminder = '';
    };

    public save = (): void => {
        this.medicalExamCertificate.save()
            .subscribe(
                result => {
                    if (!!result) {
                        this.dialogRef.close(result);
                    }
                },
                err => this.handleErrors(err.error)
            );
    };

    private handleErrors(e: any) {
        if (e && e.validationResults) {

            let blockingValidationResults = e.validationResults.filter(i => 'REDIRECT_ADMINISTRATIVE_ACTION' != i.state.errorCode);

            if (!!blockingValidationResults && blockingValidationResults.length > 0) {
                this.handleValidationResult(e);
                return;
            }

            this.incidentConfirmationService.confirmIncidentRedirect(null, e, this.dialogRef);
            // the incident redirect will only close if confirm is clicked.
            // Want to close MEC modal regardless, otherwise it looks like we didn't save anything when we actually did
            this.dialogRef.close();
        }
    }

    public close = (): void => {
        this.dialogRef.close();
    };

    public formValidationStatus = (event: boolean): void => {
        this.isFormValid = event;
    };

    public isSaving = (event: boolean): void => {
        this.saving = event;
    };

    public setEligibilityStatus = (event: any): void => {
        this.showEligibilityStatus = true;
        this.eligibilityStatus = event.eligibilityStatus;
        this.eligibilityMessage = event.eligibilityMessage;
    };

    public showWaiverStatus = (event: any): void => {
        this.waiverStatus = event;
    };

    public showDateReminder = (event: any): void => {
        this.dateReminder = event;
    };
}
